import { makeStyles } from '@mui/styles';

export const useOverwriteHighlightStyles = makeStyles(() => ({
  highlightedCell: {
    color: '#4580FF',
  },
  highlightedRow: {
    '& > div': {
      backgroundColor: '#E6ECF9',
    },
  },
}));

export const useErrorHighlightStyles = makeStyles(() => ({
  highlightedCell: {
    color: '#FF2D55',
  },
  highlightedRow: {
    '& > div': {
      backgroundColor: '#F8E4E8',
    },
  },
}));
